module.exports = __webpack_public_path__ + "assets/JTUSjIg1_i6t8kCHKm459Wdhyzbi-2c36ce.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/JTUSjIg1_i6t8kCHKm459Wdhyzbi.woff2
// module id = 847
// module chunks = 2